var AppCtrl = function($log, $rootScope, $scope, $state, $window, $document, $location, $timeout, $sce, $interval, localStorageService, appConfig, HelperService) {

    // Globals

    $rootScope.appConfig = appConfig;

    $rootScope.now = new Date();
    $rootScope.$state = $state;

    $rootScope.mobile = Detectizr.device.type === 'mobile';
    $rootScope.tablet = Detectizr.device.type === 'tablet';

    $rootScope.$helper = HelperService;
    $rootScope.$location = $location;

    // Initialise

    viewportUnitsBuggyfill.init();

    // State events

    $rootScope.$on('$stateChangeError', function($event, toState, toParams, fromState, fromParams, error) {
        $event.preventDefault();

        $log.error(error);
    });

    $rootScope.$on('$stateChangeSuccess', function($event, toState, toParams, fromState, fromParams) {
        $rootScope.stateName = toState.name;

        if (typeof ga !== 'undefined') {
            ga('send', 'pageview', {
                'page': $location.path()
            });
        }
    });

    // Enable pinterest

    $timeout(function() {
        $rootScope.pinterestEnable = true;
    }, 2000);

    // Background color

    var colors = [
        'green',
        'yellow',
        'pink',
    ];

    var color = 0;

    if (localStorageService.get('color') !== null) {
        color = localStorageService.get('color');
        color = color < colors.length - 1 ? color + 1 : 0;
    }

    localStorageService.set('color', color);

    $rootScope.backgroundColor = colors[color];

};

angular.module('webApp.controllers').controller('AppCtrl', AppCtrl);
